// we're thunking here so we don't have to pass the whole form values state around the entirity of AS
// (avoiding re-renders on every input change)

import axios from "axios";
import { getFormValues } from "redux-form";
import queryString from "query-string";
import { omit } from "lodash";

// params that only shape/sort a search - on their own they'd return every venue
const NON_CRITERIA_PARAMS = [
  "sortBy",
  "results",
  "closePanels",
  "uuid",
  "update_on_move",
  "types_text",
  "agency",
  "company",
  "location_type",
  "radius",
  "back_projection",
  "exhibition",
  "groupName",
];

const hasSearchCriteria = params =>
  Object.keys(params).some(key => {
    if (NON_CRITERIA_PARAMS.includes(key)) return false;
    const value = params[key];
    if (Array.isArray(value)) return value.length > 0;
    return value !== null && value !== undefined && value !== "";
  });

const search = (
  history,
  localStateSetter,
  v,
  cancelToken = false,
  requireCriteria = false
) => (d, getState) => {
  const params = {
    ...getFormValues("advanced-search")(getState()),
    ...v,
  };

  if (requireCriteria && !hasSearchCriteria(params)) {
    return;
  }

  localStateSetter.loading();

  if (params.update_on_move) delete params.update_on_move;

  Object.keys(params).forEach(v => {
    if (params[v] === "") delete params[v];
  });

  if (params.uuid) {
    delete params.uuid;
  }

  const payload = {
    params,
  };

  if (cancelToken !== false) {
    payload.cancelToken = cancelToken;
  }
  axios
    .get(`${window.NODE_AS}/`, payload)
    .then(r => {
      if (
        history.location.pathname === "/advanced-search" ||
        history.location.pathname === "/corporate/advanced-search"
      ) {
        let prefProgramme =
          params &&
          params["sortBy"] &&
          params["sortBy"] === "Preferred Programme";
        localStateSetter.results(r.data.data, r.data.count, prefProgramme, v);
        history.push(
          history.location.pathname +
            `?results=${r.data.count}&${queryString.stringify(
              omit(params, ["placeArea"])
            )}`
        );
      }
    })
    .catch(err => {
      if (history.location.pathname === "/advanced-search") {
        localStateSetter.error();
      }
    });
};

export { search };
